import { PaginationType } from "src/models/common/PaginationType.model";
import { updateAssignee, UpdatePAN, SkipPANFormFill } from "src/models/PAN.model";
import apiSlice from "./ApiSlice";

export const panApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // POST REQUEST
    getPan: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/list/pagination",
        method: "POST",
        body,
      }),
    }),

    // POST REQUEST
    getUserPan: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/user/list/pagination",
        method: "POST",
        body,
      }),
    }),



    // GET REPORT
    getPanZip: builder.mutation({
      query: (srn) => ({
        url: `/pan-app/zip`,
        params: { srn },
        method: "GET",
      }),
    }),

    // Export Data
    exportHistoryPanData: builder.mutation({
      query: (body: PaginationType) => ({
        url: "/pan-app/list/pagination",
        method: "POST",
        body,
      }),
    }),

    // GET SINGLE
    getSinglePan: builder.query({
      providesTags: ["pan-app"],
      query: (panId) => ({
        url: `/pan-app/admin/view`,
        params: { id: panId },
        method: "GET",
      }),
    }),

    // GET FLOW
    getPanApplicationFlow: builder.mutation({
      query: (id) => ({
        url: `/pan-app/get-status-history`,
        params: { id: id },
        method: "PUT",
      }),
    }),

    // Change status
    changePANStatus: builder.mutation({
      invalidatesTags: ["pan-app", "pending-applications"],
      query: ({ body, id }: UpdatePAN) => ({
        url: `/pan-app/update-status`,
        params: { id },
        method: "PUT",
        body,
      }),
    }),

    // Skip both form-fill steps: IN_PROGRESS -> VERIFY in one hop.
    //
    // Plain JSON body: the bypass carries no acknowledgement PDF, so this route
    // has no multipart parser. Separate from /update-status only so it can carry
    // its own SKIP_FORM_FILL permission, which makes the bypass grantable per role.
    skipPANFormFill: builder.mutation({
      invalidatesTags: ["pan-app", "pending-applications"],
      query: ({ body, id }: SkipPANFormFill) => ({
        url: `/pan-app/skip-form-fill`,
        params: { id },
        method: "PUT",
        body,
      }),
    }),

    //assignee
    changePANApplicationAssignee: builder.mutation({
      invalidatesTags: ["pan-app"],
      query: ({ body, id }: updateAssignee) => ({
        url: `/pan-app/assign-to`,
        params: { id },
        method: "POST",
        body,
      }),
    }),

    // GET STATUS COUNT
    getPANStatusWiseCount: builder.query({
      providesTags: ["pan-app"],
      query: () => ({
        url: "/pan-app/get-allstatuscounts",
        method: "GET",
      }),
    }),

    // GET STATUS WISE APPLICATIONS

    //PENDING  REQUEST
    getPanPendingApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-pending-applications",
        method: "POST",
        body,
      }),
    }),

    //VERIFIED  REQUEST
    getPanVerifiedApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-verified-applications",
        method: "POST",
        body,
      }),
    }),
    //REJECTED  REQUEST
    getPanRejectedApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-rejected-applications",
        method: "POST",
        body,
      }),
    }),
    //IN RPOGRESS  REQUEST
    getPanInProgressApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-inprogress-applications",
        method: "POST",
        body,
      }),
    }),
    //FORM FILL PENDING REQUEST
    getPanFormFillPendingApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-formfill-pending-applications",
        method: "POST",
        body,
      }),
    }),

    //FORM FILL IN PROGRESS REQUEST
    getPanFormFillInProgressApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-formfill-inprogress-applications",
        method: "POST",
        body,
      }),
    }),

    //Done REQUEST
    getPanDoneApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-done-applications",
        method: "POST",
        body,
      }),
    }),

    //CANCELLED REQUEST
    getPanCancelledApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-cancelled-applications",
        method: "POST",
        body,
      }),
    }),

    //Generate REQUEST
    getPanGenerateApplications: builder.query({
      providesTags: ["pan-app"],
      query: (body: PaginationType) => ({
        url: "/pan-app/get-generate-applications",
        method: "POST",
        body,
      }),
    }),

    // work history PAN Application
    getPanApplicationWorkHistory: builder.query({
      providesTags: ["pan-app"],
      query: (body: any) => ({
        url: "/pan-app/admin-history",
        method: "POST",
        body,
      }),
    }),

    //To Get Payemnt summarry

     getPanApplicationPaymentSummary: builder.query({
      providesTags: ["pan-app"],
      query: (body: any) => ({
        url: "/pan-app/payment-detail",
        method: "POST",
        body,
      }),
    }),

    // Generate + save the filled PAN form PDF (returns the stored file URL)
    addPanForm: builder.mutation({
      invalidatesTags: ["pan-app"],
      query: (body) => ({
        url: "/pan-form/add",
        method: "POST",
        body,
      }),
    }),

    /*
      Save the photo / signature as edited in the PAN form, as <ack>_Photo /
      <ack>_Sig, on "Next: Preview". Body: { panId, photo?, signature? } where
      each is an image data-URL (save it), "" (clear the edited copy) or absent
      (leave it). The applicant's own uploads are never touched.

      No invalidation on purpose: refetching the application mid-form would
      buy nothing here, and the details page re-reads it when it next loads.
    */
    savePanFormImages: builder.mutation({
      query: (body: { panId: string; photo?: string; signature?: string }) => ({
        url: "/pan-form/save-images",
        method: "POST",
        body,
      }),
    }),

    /*
      Attach an extra file to an application from the PAN details page. The body
      is FormData (document + panId + title + remark + fileType) — do NOT set a
      Content-Type header, the browser has to write its own multipart boundary.

      Invalidating "pan-app" is what refreshes the documents grid: the files come
      back on the application record, so there is no separate list query.
    */
    uploadPanExtraFile: builder.mutation({
      invalidatesTags: ["pan-app"],
      query: (body: FormData) => ({
        url: "/pan-app/upload-file",
        method: "POST",
        body,
      }),
    }),

    /*
      Set or clear the temporary "document still needed" note. An empty remark
      clears it, which is what the Clear action sends. Attaching a file clears
      it on the API side too, so the note settles itself once the document
      arrives.
    */
    setPanTempRemark: builder.mutation({
      invalidatesTags: ["pan-app"],
      query: (body: { panId: string; remark: string }) => ({
        url: "/pan-app/temp-remark",
        method: "PUT",
        body,
      }),
    }),

    // Remove one attached file by its fileId.
    deletePanExtraFile: builder.mutation({
      invalidatesTags: ["pan-app"],
      query: (body: { panId: string; fileId: string }) => ({
        url: "/pan-app/uploaded-file",
        method: "DELETE",
        body,
      }),
    }),

    // Fetch the saved PAN form record for a PAN application (by panId).
    // Used to decide direct-download (file exists) vs generate (no file yet).
    getPanFormByPanId: builder.query({
      providesTags: ["pan-app"],
      query: (id: string) => ({
        url: `/pan-form/view`,
        method: "GET",
        params: { id },
      }),
    }),

    // Earlier PAN form PDFs that a refill replaced (VIEW_OLD_PAN_FORM only).
    getPanPreviousForms: builder.query({
      providesTags: ["pan-app"],
      query: (id: string) => ({
        url: `/pan-form/previous-forms`,
        method: "GET",
        params: { id },
      }),
    }),

    /*
      GENERATE tab AUTO DOWNLOAD: one zip of the ticked applications' PAN form
      PDF / affidavit / photo / signature / vendor XLSX. The counts come back as
      headers because the body is the zip itself.
    */
    generatePanAutoDownload: builder.mutation({
      query: (body: {
        ids: string[];
        include: {
          panForm: boolean;
          affidavit: boolean;
          photo: boolean;
          sign: boolean;
          vendorXlsx: boolean;
        };
      }) => ({
        url: `/pan-form/generate-auto-download`,
        method: "POST",
        body,
        responseHandler: (response: any) =>
          response.ok ? response.blob() : response.json(),
      }),
      transformResponse: (blob: Blob, meta: any) => {
        const headers = meta?.response?.headers;
        const disposition: string = headers?.get("Content-Disposition") || "";
        const match = disposition.match(/filename="?([^";]+)"?/i);
        return {
          blob,
          fileName: match?.[1] || "pan_generate.zip",
          applicationCount: Number(headers?.get("X-Application-Count") || 0),
          missingCount: Number(headers?.get("X-Missing-Count") || 0),
        };
      },
    }),

  }),
});

export const {
  useGetPanQuery,
  useGetUserPanQuery,
  useGetSinglePanQuery,
  useGetPanApplicationPaymentSummaryQuery,
  useChangePANApplicationAssigneeMutation,
  useGetPanPendingApplicationsQuery,
  useChangePANStatusMutation,
  useSkipPANFormFillMutation,
  useExportHistoryPanDataMutation,
  useGetPanZipMutation,
  useGetPANStatusWiseCountQuery,
  useGetPanCancelledApplicationsQuery,
  useGetPanDoneApplicationsQuery,
  useGetPanGenerateApplicationsQuery,
  useGetPanInProgressApplicationsQuery,
  useGetPanFormFillPendingApplicationsQuery,
  useGetPanFormFillInProgressApplicationsQuery,
  useGetPanRejectedApplicationsQuery,
  useGetPanVerifiedApplicationsQuery,
  useGetPanApplicationFlowMutation,
  useGetPanApplicationWorkHistoryQuery,
  useAddPanFormMutation,
  useSavePanFormImagesMutation,
  useUploadPanExtraFileMutation,
  useSetPanTempRemarkMutation,
  useDeletePanExtraFileMutation,
  useLazyGetPanFormByPanIdQuery,
  useGetPanFormByPanIdQuery,
  useGetPanPreviousFormsQuery,
  useGeneratePanAutoDownloadMutation,
} = panApi;
